import { useEffect, useState } from 'react';

const WAITING_TIP_KEYS = [
  'chat.waitingTips.tip1',
  'chat.waitingTips.tip2',
  'chat.waitingTips.tip3',
  'chat.waitingTips.tip4',
  'chat.waitingTips.tip5',
  'chat.waitingTips.tip6',
  'chat.waitingTips.tip7',
  'chat.waitingTips.tip8',
  'chat.waitingTips.tip9',
  'chat.waitingTips.tip10',
  'chat.waitingTips.tip11',
] as const;

const getRandomTipIndex = (excludeIndex?: number) => {
  const max = WAITING_TIP_KEYS.length;
  if (max <= 1) return 0;

  let next = Math.floor(Math.random() * max);
  if (excludeIndex !== undefined && next === excludeIndex) {
    next = (next + 1) % max;
  }

  return next;
};

export function useWaitingTips(isWaiting: boolean) {
  const [tipIndex, setTipIndex] = useState(() => getRandomTipIndex());

  useEffect(() => {
    if (!isWaiting) {
      return;
    }

    setTipIndex(prev => getRandomTipIndex(prev));
    const intervalId = setInterval(() => {
      setTipIndex(prev => getRandomTipIndex(prev));
    }, 30000);

    return () => {
      clearInterval(intervalId);
    };
  }, [isWaiting]);

  return WAITING_TIP_KEYS[tipIndex];
}
